// PianoSalamanderUltimate.js
// ULTIMATE QUALITY Salamander Grand Piano
// Sampled every minor third (3 semitones) with 3 velocity layers
// Tone.js will interpolate between these samples for perfect pitch

// Soft velocity layer (piano - v4)
export const PIANO_SALAMANDER_SOFT = {
    A0: "A0_soft.mp3",
    C1: "C1_soft.mp3",
    "D#1": "Ds1_soft.mp3",
    "F#1": "Fs1_soft.mp3",
    A1: "A1_soft.mp3",
    C2: "C2_soft.mp3",
    "D#2": "Ds2_soft.mp3",
    "F#2": "Fs2_soft.mp3",
    A2: "A2_soft.mp3",
    C3: "C3_soft.mp3",
    "D#3": "Ds3_soft.mp3",
    "F#3": "Fs3_soft.mp3",
    A3: "A3_soft.mp3",
    C4: "C4_soft.mp3",
    "D#4": "Ds4_soft.mp3",
    "F#4": "Fs4_soft.mp3",
    A4: "A4_soft.mp3",
    C5: "C5_soft.mp3",
    "D#5": "Ds5_soft.mp3",
    "F#5": "Fs5_soft.mp3",
    A5: "A5_soft.mp3",
    C6: "C6_soft.mp3",
    "D#6": "Ds6_soft.mp3",
    "F#6": "Fs6_soft.mp3",
    A6: "A6_soft.mp3",
    C7: "C7_soft.mp3",
    "D#7": "Ds7_soft.mp3",
    "F#7": "Fs7_soft.mp3",
    A7: "A7_soft.mp3",
    C8: "C8_soft.mp3"
};

// Medium velocity layer (mezzo-forte - v8)
export const PIANO_SALAMANDER_MEDIUM = {
    A0: "A0_medium.mp3",
    C1: "C1_medium.mp3",
    "D#1": "Ds1_medium.mp3",
    "F#1": "Fs1_medium.mp3",
    A1: "A1_medium.mp3",
    C2: "C2_medium.mp3",
    "D#2": "Ds2_medium.mp3",
    "F#2": "Fs2_medium.mp3",
    A2: "A2_medium.mp3",
    C3: "C3_medium.mp3",
    "D#3": "Ds3_medium.mp3",
    "F#3": "Fs3_medium.mp3",
    A3: "A3_medium.mp3",
    C4: "C4_medium.mp3",
    "D#4": "Ds4_medium.mp3",
    "F#4": "Fs4_medium.mp3",
    A4: "A4_medium.mp3",
    C5: "C5_medium.mp3",
    "D#5": "Ds5_medium.mp3",
    "F#5": "Fs5_medium.mp3",
    A5: "A5_medium.mp3",
    C6: "C6_medium.mp3",
    "D#6": "Ds6_medium.mp3",
    "F#6": "Fs6_medium.mp3",
    A6: "A6_medium.mp3",
    C7: "C7_medium.mp3",
    "D#7": "Ds7_medium.mp3",
    "F#7": "Fs7_medium.mp3",
    A7: "A7_medium.mp3",
    C8: "C8_medium.mp3"
};

// Loud velocity layer (forte - v12)
export const PIANO_SALAMANDER_LOUD = {
    A0: "A0_loud.mp3",
    C1: "C1_loud.mp3",
    "D#1": "Ds1_loud.mp3",
    "F#1": "Fs1_loud.mp3",
    A1: "A1_loud.mp3",
    C2: "C2_loud.mp3",
    "D#2": "Ds2_loud.mp3",
    "F#2": "Fs2_loud.mp3",
    A2: "A2_loud.mp3",
    C3: "C3_loud.mp3",
    "D#3": "Ds3_loud.mp3",
    "F#3": "Fs3_loud.mp3",
    A3: "A3_loud.mp3",
    C4: "C4_loud.mp3",
    "D#4": "Ds4_loud.mp3",
    "F#4": "Fs4_loud.mp3",
    A4: "A4_loud.mp3",
    C5: "C5_loud.mp3",
    "D#5": "Ds5_loud.mp3",
    "F#5": "Fs5_loud.mp3",
    A5: "A5_loud.mp3",
    C6: "C6_loud.mp3",
    "D#6": "Ds6_loud.mp3",
    "F#6": "Fs6_loud.mp3",
    A6: "A6_loud.mp3",
    C7: "C7_loud.mp3",
    "D#7": "Ds7_loud.mp3",
    "F#7": "Fs7_loud.mp3",
    A7: "A7_loud.mp3",
    C8: "C8_loud.mp3"
};

// Default export uses medium velocity (most versatile)
export const PIANO_SALAMANDER = PIANO_SALAMANDER_MEDIUM;


